<template>
  <div class="cf">
    <div v-if="vodObject.isAdClickAble()"  class="cfIcon" @click.prevent="click"><img src="@/assets/images/ad_click.png"></div>
    <div v-if="vodObject.isCurrentAdSkipAble() === true" class="skipText" @click.prevent="skip">{{ getSkipText() }}</div>
    <div v-else class="skipText">광고중 입니다</div>
    <div class="skipBg"></div>
  </div>
</template>
<script>
export default {
  name: 'AdvertisementUI',
  props: {
    vodObject: {
      type: Object
    }
  },
  data() {
    return {
      adSkipCount: 15,
      adPlaying: true
    }
  },
  mounted () {
    this.$emit('on-load', this)
    if (this.vodObject.isCurrentAdSkipAble()) this.adSkipCount = this.vodObject.getCurrentAdSkipTime()
  },
  methods : {
    onAdStarted () {
      if (this.vodObject.isCurrentAdSkipAble()) {
        this.timerId = setInterval(() => {
          if (this.adPlaying) this.adSkipCount--
          if (this.adSkipCount <= 0 ) clearInterval(this.timerId)
        }, 1000);
      }
    },
    onPaused () {
      this.adPlaying = false
    },
    onResumed () {
      this.adPlaying = true
    },
    getSkipText () {
      if (this.adSkipCount <= 0 ) return '건너뛰기'
      else return ( this.adSkipCount + '초 후 건너뛰기' )
    },
    skip () {
      if (this.adSkipCount <= 0) {
        this.vodObject.sendAdLog('skip')
        this.$parent.changeAd()
      }
    },
    click () {
      window.opened = window.open(this.vodObject.getCurrClickUrl())
      window.opened.window.focus()
      this.vodObject.sendAdLog('click')
    }
  }
}
</script>
<style>
.cf { position: absolute; top: 0px; width: 100%; height: 100%; }
.cf .cfIcon { position: absolute; left: 17px; bottom: 50px; z-index: 1; }
.cf .cfIcon img {width: 50px;  height: 50px;}
.cf .skipText { right:0px; bottom: 55px; width: 106px; position: absolute; z-index: 2; color: #fff; font-size: 12px; text-align: center;}
.cf .skipBg { right: 0px; bottom: 50px; width: 106px; height: 26px; background: #000000; opacity: 0.2; position: absolute; z-index: 1; }
</style>
